import { render, staticRenderFns } from "./IndicatorCard.vue?vue&type=template&id=65a40e1e&scoped=true"
import script from "./IndicatorCard.vue?vue&type=script&lang=js"
export * from "./IndicatorCard.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=65a40e1e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a40e1e",
  null
  
)

export default component.exports